// import React, { useEffect, useState } from 'react';
// import Navbar from '../../Components/Navbar';
// import Table from 'react-bootstrap/Table';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import './SubmittedGrant.css';
// import { API_BASE_URL } from '../../config';
// import SelectYear from '../../Components/SelectYear'; // Import the SelectYear component


// export default function SubmittedGrant() {
//   const [submittedGrants, setSubmittedGrants] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [currentGrantId, setCurrentGrantId] = useState(null);
//   const [selectedYear, setSelectedYear] = useState('');
//   const [filteredApplications, setFilteredApplications] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchSubmittedGrants = async () => {
//       try {
//         const response = await axios.get('/SubmittedGrants.php');
//         if (Array.isArray(response.data)) {
//           setSubmittedGrants(response.data);
//         } else {
//           console.error('Expected an array but received:', response.data);
//         }
//       } catch (error) {
//         console.error('Error fetching submitted grants:', error);
//       }
//     };

//     fetchSubmittedGrants();
//   }, []);

//   const handleUploadAgreement = (grantId) => {
//     setCurrentGrantId(grantId); // Set the grant ID for the modal
//     setShowModal(true); // Show the modal
//   };

//   const handleFileChange = (event) => {
//     setSelectedFile(event.target.files[0]); // Set the selected file
//   };
  
//   const handleDownloadAgreement = (grantId) => {
//     console.log(`Download agreement for grant with ID: ${grantId}`);
    
//     // Trigger a GET request to fetch the agreement file
//     axios
//       .get(`${API_BASE_URL}/SubmittedGrants.php?grantId=${grantId}`, {
//         responseType: 'blob', // Ensure we receive the file as a blob
//       })
//       .then((response) => {
//         // Create a link element to trigger the download
//         const link = document.createElement('a');
//         const blob = new Blob([response.data], { type: 'application/pdf' });
//         link.href = URL.createObjectURL(blob);
//         link.download = `${grantId}_Agreement.pdf`; // Set the file name
//         link.click();
  
//         // Clean up the object URL
//         URL.revokeObjectURL(link.href);
//       })
//       .catch((error) => {
//         console.error('Error downloading agreement:', error);
//         alert('An error occurred while downloading the agreement.');
//       });
//   };
  
  
//   const handleFileUpload = async () => {
//     if (!selectedFile) {
//       alert('Please select a file to upload.');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', selectedFile);
//     formData.append('grantId', currentGrantId);

//     try {
//       const response = await axios.post(`${API_BASE_URL}/SubmittedGrants.php`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });

//       if (response.data.success) {
//         alert('File uploaded successfully!');
//       } else {
//         alert('File upload failed.');
//       }
//     } catch (error) {
//       console.error('Error uploading file:', error);
//       alert('An error occurred while uploading the file.');
//     } finally {
//       setShowModal(false); // Close the modal
//       setSelectedFile(null); // Reset the file input
//     }
//   };
//   const handleClick = (Id) => {
//     navigate(`/moredetails/${Id}`); // Correctly use template literal
//   };
//   const handleView = async (app_ID) => {
//     try {
//       const response = await axios.get(`/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
//         responseType: 'blob', // Expect binary data (PDF file)
//       });
  
//       // Create a Blob object and generate a download link
//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       // link.download = `Application_${app_ID}.pdf`; // Set the downloaded file's name
//       link.download = `Application_${new Date().getFullYear()}_${app_ID}.pdf`;
//       link.click();
  
//       // Cleanup
//       URL.revokeObjectURL(link.href);
//     } catch (error) {
//       console.error('Error downloading the file:', error);
//       alert('An error occurred while downloading the application.');
//     }
//   };
  
//   const handleDeleteClick = async (app_ID) => {
//     if (window.confirm('Are you sure you want to delete this application?')) {
//       try {
//         // Send the request to delete the application
//         const response = await axios.post(`${API_BASE_URL}/DeleteApplication.php`, { app_ID });
  
//         if (response.data.success) {
//           // Update state to remove the deleted application
//           setSubmittedGrants(submittedGrants.filter((app) => app.app_ID !== app_ID));
//           alert('Application deleted successfully.');
//         } else {
//           alert(`Failed to delete application: ${response.data.message}`);
//         }
//       } catch (error) {
//         console.error('Error deleting application:', error);
//         alert('An error occurred while deleting the application.');
//       }
//     }
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Submitted Grants</h1>
//       <Table
//         striped
//         bordered
//         hover
//         style={{ marginTop: '20px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)' }}
//       >
//         <thead>
//           <tr>
//             <th>Application Id</th>
//             <th>Project Title</th>
//             <th>Submitted Date</th>
//             <th>Status</th>
//             <th>Grant (Pdf)</th>
//             <th>Agreements</th>
//             <th>Application Details</th>
//             <th>Delete Application</th>
//           </tr>
//         </thead>
       
//         <tbody>
//   {submittedGrants.length > 0 ? (
//     submittedGrants.map((grant, index) => (
//       <tr key={`${grant.pID}-${index}`}>
//         <td>{grant.Id}</td>
//         <td>{grant.projectTitle}</td>
//         <td>{grant.submittedDate}</td>
//         <td>
//           {grant.Status === 'Save' ? (
//             <>
//               <span>{grant.Status}</span>
//               <button
//                 className="Edit_Button"
//                 onClick={() => navigate('/editgrant', { state: { appId: grant.Id } })}
//               >
//                 Edit
//               </button>
//             </>
//           ) : (
//             <span>{grant.Status}</span>
//           )}
//         </td>
//         <td>
//   {grant.Status === 'Save' ? (
//     <span>Not Available</span>
//   ) : (
//     <button
//       onClick={() => handleView(grant.Id)} // Pass the app_ID to the function
//       className="View_Button"
//     >
//       View
//     </button>
//   )}
// </td>

//         <td>
//           {grant.hasAgreement ? (
//             <>
//               <button
//                 className="DownloadUpload_Button"
//                 onClick={() => handleDownloadAgreement(grant.Id)}
//               >
//                 Download
//               </button>
//               <button
//                 className="DownloadUpload_Button"
//                 onClick={() => handleUploadAgreement(grant.Id)}
//               >
//                 Upload
//               </button>
//             </>
//           ) : (
//             <span>Not Available</span>
//           )}
//         </td>
//         <td>
//                 <button 
//                   className="moreDetails-button" // Add your custom class name for styling
//                   onClick={() => handleClick(grant.Id)} // Navigate to More Details
//                 >
//                  More Details
//                 </button>
//               </td>
//               <td>
//                 <button className="delete-button" onClick={() => handleDeleteClick(grant.Id)}>
//                   Delete
//                 </button>
//               </td>
//       </tr>
//     ))
//   ) : (
//     <tr>
//       <td colSpan="6" style={{ textAlign: 'center' }}>
//         No submitted grants found.
//       </td>
//     </tr>
//   )}
// </tbody>
//       </Table>

//       {/* Modal for Uploading File */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Upload Agreement</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formFile">
//               <Form.Label>Select File (Upload the PDF of the Agreement)</Form.Label>
//               <Form.Control type="file" onChange={handleFileChange} />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary"  onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" className='modalupdatebutton' onClick={handleFileUpload}>
//             Upload
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import Navbar from '../../Components/Navbar';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './SubmittedGrant.css';
import { API_BASE_URL } from '../../config';
import SelectYear from '../../Components/SelectYear'; // Import the SelectYear component

export default function SubmittedGrant() {
  const [submittedGrants, setSubmittedGrants] = useState([]);
  const [filteredGrants, setFilteredGrants] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [currentGrantId, setCurrentGrantId] = useState(null);
  const [selectedYear, setSelectedYear] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSubmittedGrants = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/SubmittedGrants.php`);
        if (Array.isArray(response.data)) {
          setSubmittedGrants(response.data);
          setFilteredGrants(response.data); // Initialize filtered grants
        } else {
          console.error('Expected an array but received:', response.data);
          setSubmittedGrants([]);
          setFilteredGrants([]);
        }
      } catch (error) {
        console.error('Error fetching submitted grants:', error);
        setSubmittedGrants([]);
        setFilteredGrants([]);
      }
    };

    fetchSubmittedGrants();
  }, []);

  // Filter grants based on selected year
  useEffect(() => {
    const filtered = selectedYear
      ? submittedGrants.filter((grant) => 
          new Date(grant.submittedDate).getFullYear().toString() === selectedYear
        )
      : submittedGrants;
    setFilteredGrants(filtered);
  }, [selectedYear, submittedGrants]);

  const handleUploadAgreement = (grantId) => {
    setCurrentGrantId(grantId);
    setShowModal(true);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleDownloadAgreement = (grantId) => {
    axios
      .get(`${API_BASE_URL}/SubmittedGrants.php?grantId=${grantId}`, {
        responseType: 'blob',
      })
      .then((response) => {
        const link = document.createElement('a');
        const blob = new Blob([response.data], { type: 'application/pdf' });
        link.href = URL.createObjectURL(blob);
        link.download = `${grantId}_Agreement.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.error('Error downloading agreement:', error);
        alert('An error occurred while downloading the agreement.');
      });
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert('Please select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('grantId', currentGrantId);

    try {
      const response = await axios.post(`${API_BASE_URL}/SubmittedGrants.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.success) {
        alert('File uploaded successfully!');
        // Re-fetch grants to update the table
        const fetchResponse = await axios.get(`${API_BASE_URL}/SubmittedGrants.php`);
        if (Array.isArray(fetchResponse.data)) {
          setSubmittedGrants(fetchResponse.data);
          // Filtering will be handled by the useEffect hook
        } else {
          console.error('Expected an array but received:', fetchResponse.data);
          setSubmittedGrants([]);
          setFilteredGrants([]);
        }
      } else {
        alert('File upload failed.');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('An error occurred while uploading the file.');
    } finally {
      setShowModal(false);
      setSelectedFile(null);
    }
  };

  const handleClick = (Id) => {
    navigate(`/moredetails/${Id}`);
  };

  const handleView = async (Id) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${Id}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Application_${new Date().getFullYear()}_${Id}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('An error occurred while downloading the application.');
    }
  };

  const handleDeleteClick = async (Id) => {
    if (window.confirm('Are you sure you want to delete this application?')) {
      try {
        const response = await axios.post(`${API_BASE_URL}/DeleteApplication.php`, { app_ID: Id });

        if (response.data.success) {
          const updatedGrants = submittedGrants.filter((app) => app.Id !== Id);
          setSubmittedGrants(updatedGrants);
          // Filtering will be handled by the useEffect hook
          alert('Application deleted successfully.');
        } else {
          alert(`Failed to delete application: ${response.data.message}`);
        }
      } catch (error) {
        console.error('Error deleting application:', error);
        alert('An error occurred while deleting the application.');
      }
    }
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Submitted Grants</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <SelectYear selectedYear={selectedYear} handleYearChange={setSelectedYear} />
      </div>
      <Table
        striped
        bordered
        hover
        style={{ marginTop: '20px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)' }}
      >
        <thead>
          <tr>
            <th>No</th>
            <th>Application Id</th>
            <th>Project Title</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Grant (Pdf)</th>
            <th>Agreements</th>
            <th>Application Details</th>
            <th>Delete Application</th>
          </tr>
        </thead>
        <tbody>
          {filteredGrants.length > 0 ? (
            filteredGrants.map((grant, index) => (
              <tr key={`${grant.pID}-${index}`}>
                <td>{index + 1}</td>
                <td>{`${grant.Id}_${grant.app_type}_${grant.submittedDate ? new Date(grant.submittedDate).getFullYear() : ""}`}</td>
                <td>{grant.projectTitle}</td>
                <td>{grant.submittedDate}</td>
                <td>
                  {grant.Status === 'Save' ? (
                    <>
                      <span>{grant.Status}</span>
                      <button
                        className="Edit_Button"
                        onClick={() => navigate('/editgrant', { state: { appId: grant.Id } })}
                      >
                        Edit
                      </button>
                    </>
                  ) : (
                    <span>{grant.Status}</span>
                  )}
                </td>
                <td>
                  {grant.Status === 'Save' ? (
                    <span>Not Available</span>
                  ) : (
                    <button
                      onClick={() => handleView(grant.Id)}
                      className="View_Button"
                    >
                      View
                    </button>
                  )}
                </td>
                <td>
                  {grant.hasAgreement ? (
                    <>
                      <button
                        className="DownloadUpload_Button"
                        onClick={() => handleDownloadAgreement(grant.Id)}
                      >
                        Download
                      </button>
                      <button
                        className="DownloadUpload_Button"
                        onClick={() => handleUploadAgreement(grant.Id)}
                      >
                        Upload
                      </button>
                    </>
                  ) : (
                    <span>Not Available</span>
                  )}
                </td>
                <td>
                  <button
                    className="moreDetails-button"
                    onClick={() => handleClick(grant.Id)}
                  >
                    More Details
                  </button>
                </td>
                <td>
                  <button
                    className="delete-button"
                    onClick={() => handleDeleteClick(grant.Id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                No submitted grants found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Modal for Uploading File */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formFile">
              <Form.Label>Select File (Upload the PDF of the Agreement)</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" className="modalupdatebutton" onClick={handleFileUpload}>
            Upload
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}